import React, { useState } from 'react';
import dryftService from '../services/dryftService';
import DryftDryRunResult from './DryftDryRunResult';

// Detail-page live dry-run — pick one of the project's hotels and fetch its watched config from OHIP
// right now. The server resolves the watched sub-areas from the project's routes (dryft_id); the hotel's
// saved OHIP credential (by id) + hotel-id override drive the connection.

const DryftDryRunPanel = ({ dryftId, hotels = [] }) => {
    const [hotelRowId, setHotelRowId] = useState(hotels[0]?.id ? String(hotels[0].id) : '');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);

    const run = async () => {
        const hotel = hotels.find(h => String(h.id) === String(hotelRowId));
        if (!hotel) { setError('Select a hotel to test'); return; }
        setLoading(true);
        setError(null);
        setResult(null);
        try {
            // Pass the saved hotel row id — the server resolves its full OHIP credential context (by id) +
            // the project's watched sub-areas. No credential details travel from the client.
            const res = await dryftService.dryRun({
                dryft_hotel_id: hotel.id,
                dryft_id:       dryftId,
            });
            setResult(res.data);
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Dry run failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pi-list-panel" style={{ marginTop: 16 }}>
            <div style={{ padding: '12px 16px 4px', fontWeight: 600, fontSize: 14, color: '#374151' }}>Dry run</div>
            <div style={{ padding: '0 16px 8px', fontSize: 12.5, color: '#6b7280' }}>
                Fetch this project's watched configuration from a hotel's OHIP now and preview the live item counts.
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '4px 16px 12px', flexWrap: 'wrap' }}>
                <select className="ppw-input" style={{ maxWidth: 280 }} value={hotelRowId} onChange={e => setHotelRowId(e.target.value)}>
                    {hotels.length === 0 && <option value="">No hotels</option>}
                    {hotels.map(h => <option key={h.id} value={h.id}>{h.hotel_name || `Hotel ${h.hotel_id}`}</option>)}
                </select>
                <button className="occ-select-btn" onClick={run} disabled={loading || hotels.length === 0}>
                    {loading ? 'Testing…' : '▶ Run live test'}
                </button>
            </div>
            <div style={{ padding: '0 16px 12px' }}>
                <DryftDryRunResult result={result} loading={loading} error={error} />
            </div>
        </div>
    );
};

export default DryftDryRunPanel;
